// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:09:21

export default {
  "id": "puzzles-balls-merge-the-new-year",
  "slug": "puzzles-balls-merge-the-new-year",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3c29613f9b2e40ef94f75a7ba038ce31-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3c29613f9b2e40ef94f75a7ba038ce31/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Puzzles Balls Merge the New Year!",
      "description": "● This New Year's game is more difficult than it might seem ?! You have a playing field? on which you need to throw balls and connect the same ones??! Until you get the biggest and most beautiful one?! Save up points?! Compete with friends and colleagues to become the best?! Enjoy your game?!",
      "instructions": "1. At first it will be easy to connect the balls?, but over time there will be more and more of them??. As soon as you connect the most beautiful ball in this game, it will disappear? and give you the most points?! If one of the lines is filled with balls ?, the game will start again ?!\n2. Press and hold your finger or mouse to control the ball?. Release your finger or mouse button to let the ball? fall onto the field?!\n3. Enjoy the game?!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "3d"
      ]
    },
    "zh-CN": {
      "title": "拼图球新年大融合！",
      "description": "● 这款新年游戏比看起来更难？！你需要在比赛场地上扔球，并连接相同的球？！直到你得到最大和最漂亮的球？！积累分数？！与朋友和同事竞争成为最佳？！享受你的游戏？！",
      "instructions": "1. 刚开始连接球会很容易，但随着时间推移，球会越来越多。一旦你连接到游戏中最漂亮的球，它就会消失并给你最高分！如果一条线被球填满，游戏将重新开始！\n2. 按住你的手指或鼠标来控制球。释放手指或鼠标按钮，让球落在场上！\n3. 享受游戏！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "3D"
      ]
    },
    "zh-TW": {
      "title": "謎題球融合迎新年！",
      "description": "● 今年這款新年遊戲的難度可能比你想像的還要高？！你有一個遊戲場地，在這裡你需要丟擲球體並將相同的球體連接起來？！直到你獲得最大最漂亮的球體？！積累分數？！和朋友和同事競爭成為最佳？！享受你的遊戲？！",
      "instructions": "1. 最初連接球會很容易，但隨著時間的推移，球會越來越多？。一旦你連接了這款遊戲中最美的球，它就會消失？並給你最多的分數？！如果某條線上填滿了球？，遊戲就會重新開始？！\n2. 按住你的手指或滑鼠來控制球？。釋放手指或滑鼠按鈕，讓球？落入場地？！\n3. 享受遊戲？！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1玩家",
        "3D"
      ]
    },
    "zh-HK": {
      "title": "謎題球合併迎新年！",
      "description": "● 這個新年遊戲比你想像中難得多？！你有一個遊戲場地？在裡面你需要丟擲球並連接相同的球？！直到你得到最大和最漂亮的一個？！積累分數？！與朋友和同事競爭成為最佳？！享受你的遊戲？！",
      "instructions": "1. 初開始時連接球會很易，但隨著時間的推移，球會越來越多？。當你連接這款遊戲中最美的球時，它會消失？並給你最多的分數？！如果其中一條線上填滿了球？，遊戲將會重新開始？！\n2. 按住你的手指或滑鼠來控制球？。放開手指或滑鼠按鈕，讓球？落到場地上？！\n3. 享受遊戲？！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1玩家",
        "3D"
      ]
    },
    "ja": {
      "title": "パズルボールズ 合体で新年の！",
      "description": "● この新年のゲームは見かけ以上に難しいですか？！あなたはボールを投げて同じものを結ぶ必要があるプレイフィールドを持っていますか？！最大で最も美しいものを目指して？！ポイントをためる必要がありますか？！友人や同僚と競って一番になるために？！ゲームを楽しんでください？！",
      "instructions": "1. 最初はボールを結ぶのが簡単ですが、時間が経つにつれてどんどん増えていきます。このゲームで最も美しいボールを結んだら、それが消え去り、最高のポイントを獲得します！一つのラインがボールで満たされたら、ゲームが再開されます！\n2. ボールを操作するには、指やマウスを押し続けてください。指やマウスボタンの押し放しでボールをフィールドに落下させましょう！\n3. ゲームを楽しんでください！",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "3D"
      ]
    },
    "ko": {
      "title": "퍼즐 볼스 신년 축하합니다!",
      "description": "● 이 신년 게임은 생각보다 어려워 보이지 않나?! 당신은 볼을 던져 같은 것을 연결해야 하는 플레이 필드를 가지고 있어?! 가장 크고 아름다운 하나로 이어지는까지?! 점수를 모으는 거여?! 친구와 동료들과 경쟁하여 최고가 되는 거여?! 게임을 즐겨보세요?!",
      "instructions": "1. 원래는 볼을 연결하는 것이 쉬울 것 같지만, 시간이 지나면서 볼의 수가 점점 더 많아질 것입니다. 이 게임에서 가장 아름다운 볼을 연결하면 그 볼이 사라지고 가장 많은 점수를 주게 됩니다! 한 줄이 볼로 가득 차면 게임이 다시 시작됩니다!\n2. 볼을 제어하려면 손가락이나 마우스를 누르고 잡아놓으세요. 손가락이나 마우스 버튼을 떼면 볼이 필드에 떨어질 것입니다!\n3. 게임을 즐겨보세요?!",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "3D"
      ]
    },
    "fr": {
      "title": "Puzzles Balls Fusion du Nouvel An !",
      "description": "● Ce jeu de la nouvelle année est plus difficile qu'il ne semble ?! Vous avez un terrain de jeu ? sur lequel vous devez lancer des balle et connecter les mêmes ?! Jusqu'à ce que vous ayez le plus grand et le plus beau ?! Accumuler des points ?! Concourir avec vos amis et collègues pour devenir le meilleur ?! Profitez de votre jeu ?!",
      "instructions": "1. Au début, il sera facile de connecter les balle ?, mais au fil du temps, il y en aura de plus en plus ?. Dès que vous connecterez la plus belle balle de ce jeu, elle disparaitra ? et vous donnera le plus de points $? Si l'une des lignes est remplie de balle ?, le jeu recommencera ?!\n2. Appuyez et tenez votre doigt ou votre souris pour contrôler la balle ?. Relâchez le bouton de votre doigt ou votre souris pour faire tomber la balle sur le champ ?!\n3. Profitez du jeu $?",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1 joueur",
        "3D"
      ]
    }
  }
};
